<div class="w-full mx-auto">
  @let configValue = config();
  @let acceptValue = accept();
  @let disableValue = disabled();
  <input
    #fileInput
    class="hidden"
    type="file"
    [accept]="acceptValue"
    [disabled]="disableValue"
    [multiple]="configValue.multipleUpload"
    [name]="nameAttribute()"
    (change)="onFileInputChange($event)"
  />

  <div
    class="drop-zone cursor-pointer transition-all duration-300 rounded-lg mb-4"
    role="button"
    tabindex="0"
    [class.disabled]="disableValue"
    (click)="onClickDropZone()"
    (dragenter)="onDragEnter($event)"
    (dragleave)="onDragLeave($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    (keyup.enter)="onKeyupEnterDropZone()"
    (keyup.space)="onKeyupSpaceDropZone()"
  >
    @let dropZoneContentValue = dropZoneContent();
    @if (dropZoneContentValue !== undefined) {
      <ng-container *ngTemplateOutlet="dropZoneContentValue" />
    }
  </div>

  @let fileListContentValue = fileListContent();
  @if (fileListContentValue !== undefined) {
    <ng-container *ngTemplateOutlet="fileListContentValue" />
  }
</div>
